export var AssignmentAgeParms;
(function (AssignmentAgeParms) {
    AssignmentAgeParms[AssignmentAgeParms["OlderThan"] = 0] = "OlderThan";
    AssignmentAgeParms[AssignmentAgeParms["CreatedWithin"] = 1] = "CreatedWithin";
    AssignmentAgeParms[AssignmentAgeParms["FromWarnDate"] = 2] = "FromWarnDate";
    AssignmentAgeParms[AssignmentAgeParms["FromLateDate"] = 3] = "FromLateDate";
    AssignmentAgeParms[AssignmentAgeParms["FromEscalateDate"] = 4] = "FromEscalateDate";
    AssignmentAgeParms[AssignmentAgeParms["StartingIn"] = 5] = "StartingIn";
})(AssignmentAgeParms || (AssignmentAgeParms = {}));
;
